/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Crash_ReloadInputs */

const th_crash_reload = /** @type {(inputs: Crash_ReloadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`โหลดหน้านี้ใหม่`)
};

const en_crash_reload = /** @type {(inputs: Crash_ReloadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reload the page`)
};

const ja_crash_reload = /** @type {(inputs: Crash_ReloadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ページを再読み込み`)
};

const zh_crash_reload = /** @type {(inputs: Crash_ReloadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`重新加载页面`)
};

const es_crash_reload = /** @type {(inputs: Crash_ReloadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recargar la página`)
};

const pt_crash_reload = /** @type {(inputs: Crash_ReloadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recarregar a página`)
};

const id_crash_reload = /** @type {(inputs: Crash_ReloadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Muat ulang halaman`)
};

const fr_crash_reload = /** @type {(inputs: Crash_ReloadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recharger la page`)
};

const tl_crash_reload = /** @type {(inputs: Crash_ReloadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I-reload ang pahina`)
};

const vi_crash_reload = /** @type {(inputs: Crash_ReloadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tải lại trang`)
};

const ko_crash_reload = /** @type {(inputs: Crash_ReloadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`페이지 새로 고침`)
};

const de_crash_reload = /** @type {(inputs: Crash_ReloadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seite neu laden`)
};

const ru_crash_reload = /** @type {(inputs: Crash_ReloadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Перезагрузить страницу`)
};

const tr_crash_reload = /** @type {(inputs: Crash_ReloadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sayfayı yeniden yükle`)
};

const it_crash_reload = /** @type {(inputs: Crash_ReloadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ricarica la pagina`)
};

const pl_crash_reload = /** @type {(inputs: Crash_ReloadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Odśwież stronę`)
};

const uk_crash_reload = /** @type {(inputs: Crash_ReloadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Перезавантажити сторінку`)
};

const hi_crash_reload = /** @type {(inputs: Crash_ReloadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`पृष्ठ पुनः लोड करें`)
};

const ar_crash_reload = /** @type {(inputs: Crash_ReloadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`إعادة تحميل الصفحة`)
};

const ms_crash_reload = /** @type {(inputs: Crash_ReloadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Muat semula halaman`)
};

const bn_crash_reload = /** @type {(inputs: Crash_ReloadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`পৃষ্ঠা পুনরায় লোড করুন`)
};

const zh_tw2_crash_reload = /** @type {(inputs: Crash_ReloadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`重新載入頁面`)
};

const zh_hk2_crash_reload = /** @type {(inputs: Crash_ReloadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`重新載入頁面`)
};

const ur_crash_reload = /** @type {(inputs: Crash_ReloadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`صفحہ دوبارہ لوڈ کریں`)
};

const fa_crash_reload = /** @type {(inputs: Crash_ReloadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`بارگذاری دوبارهٔ صفحه`)
};

const sw_crash_reload = /** @type {(inputs: Crash_ReloadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pakia ukurasa upya`)
};

const nl_crash_reload = /** @type {(inputs: Crash_ReloadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pagina herladen`)
};

/**
* | output |
* | --- |
* | "Reload the page" |
*
* @param {Crash_ReloadInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const crash_reload = /** @type {((inputs?: Crash_ReloadInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Crash_ReloadInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_crash_reload(inputs)
	if (locale === "ja") return ja_crash_reload(inputs)
	if (locale === "zh") return zh_crash_reload(inputs)
	if (locale === "es") return es_crash_reload(inputs)
	if (locale === "pt") return pt_crash_reload(inputs)
	if (locale === "id") return id_crash_reload(inputs)
	if (locale === "fr") return fr_crash_reload(inputs)
	if (locale === "tl") return tl_crash_reload(inputs)
	if (locale === "vi") return vi_crash_reload(inputs)
	if (locale === "ko") return ko_crash_reload(inputs)
	if (locale === "de") return de_crash_reload(inputs)
	if (locale === "ru") return ru_crash_reload(inputs)
	if (locale === "tr") return tr_crash_reload(inputs)
	if (locale === "it") return it_crash_reload(inputs)
	if (locale === "pl") return pl_crash_reload(inputs)
	if (locale === "uk") return uk_crash_reload(inputs)
	if (locale === "hi") return hi_crash_reload(inputs)
	if (locale === "ar") return ar_crash_reload(inputs)
	if (locale === "ms") return ms_crash_reload(inputs)
	if (locale === "bn") return bn_crash_reload(inputs)
	if (locale === "zh-TW") return zh_tw2_crash_reload(inputs)
	if (locale === "zh-HK") return zh_hk2_crash_reload(inputs)
	if (locale === "ur") return ur_crash_reload(inputs)
	if (locale === "fa") return fa_crash_reload(inputs)
	if (locale === "sw") return sw_crash_reload(inputs)
	if (locale === "nl") return nl_crash_reload(inputs)
	return en_crash_reload(inputs)
});